import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { setAmplitudeUser } from "../../analytics/amplitude";
import { SecureRoute } from "../../components/SecureRoute";
import { getEnvConfig } from "../../lib/config/config";
import { User } from "../../models/user";
import { ViewType } from "../../models/view";
import { SET_USER } from "../../reducers/actions";
import { useRadarDispatch, useRadarState } from "../../reducers/reducers";
import { CUSTOMER_ORDERS_PATH } from "../page-routing-config";
import { CustomerView } from "./customer/customer-view";
import { RestaurantView } from "./restaurant/restaurant-view";

export function OrdersViewRouter() {
  const { oktaAuth } = useOktaAuth();
  const dispatch = useRadarDispatch();
  const { viewType } = useRadarState();
  const navigate = useNavigate();
  const {
    Okta: { logoutUri },
  } = getEnvConfig();

  useEffect(() => {
    async function getUser() {
      const user = await oktaAuth.getUser<User>();

      if (!oktaAuth.isAuthenticated || !user) {
        await oktaAuth.signInWithRedirect();
        return;
      }

      dispatch({ type: SET_USER, user });

      if (user && user["cfa-guid"]) {
        setAmplitudeUser(user["cfa-guid"], {
          NAME: user.name,
          EMAIL: user.email,
          TYPE: user.userType,
        });
      }
    }

    getUser();
  }, [oktaAuth, dispatch, logoutUri]);

  useEffect(() => {
    if (viewType === ViewType.CUSTOMER) {
      navigate(CUSTOMER_ORDERS_PATH, { replace: true });
    }
  }, [viewType, navigate]);

  return (
    <Routes>
      <Route
        path="restaurant"
        element={
          <SecureRoute>
            <RestaurantView />
          </SecureRoute>
        }
      />
      <Route
        path="customer"
        element={
          <SecureRoute>
            <CustomerView />
          </SecureRoute>
        }
      />
      <Route
        path="/"
        element={
          <SecureRoute>
            <Navigate to="restaurant" replace />
          </SecureRoute>
        }
      />
    </Routes>
  );
}
